import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs) || "");
}

function normalizeStrings(strings: string[]): string {
  const lineCommentPattern = /\/\/.*((\r?\n)|$)/g;

  let result = strings.join(" ");

  if (result.includes("//")) {
    result = result.replace(lineCommentPattern, "");
  }

  return result.replace(/\s+/g, " ").trim();
}

export function handleCLs(
  strings: TemplateStringsArray,
  ...expressions: ClassValue[]
): string {
  const classNamesList: string[] = strings.reduce(
    (previous, current, currentIndex) => {
      const expression = expressions[currentIndex];
      const resolvedClass = clsx(expression) || "";

      previous.push(current, resolvedClass);

      return previous;
    },
    [] as string[],
  );

  return normalizeStrings(classNamesList);
}

export function cls(
  strings: TemplateStringsArray,
  ...expressions: ClassValue[]
): string {
  return handleCLs(strings, ...expressions);
}
